import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/*',
    //   name: 'maintenance',
    //   component: () => import('./views/template/Maintenance.vue'),
    //   meta: {
    //     title: 'メンテナンス',
    //   },
    // },
    {
      path: '/admin',
      component: () => import('./views/page/Login.vue'),
      meta: {
        title: '管理者ログインページ',
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: 'top',
          component: () => import('./views/page/Top.vue'),
          meta: {
            title: '予約・進捗一覧',
            pankuzu: [],
          },
        },
        {
          path: 'plan/:date',
          component: () => import('./views/page/PlanSave.vue'),
          meta: {
            title: '予約登録',
            pankuzu: [],
          },
        },
        {
          path: 'plan/detail/:id',
          component: () => import('./views/page/PlanSave.vue'),
          meta: {
            title: '予約詳細',
            pankuzu: [],
          },
        },
        {
          path: 'tanto',
          component: () => import('./views/page/Tanto.vue'),
          meta: {
            title: '管理者一覧',
            pankuzu: [],
          },
        },
        {
          path: 'tanto_edit',
          component: () => import('./views/page/TantoEdit.vue'),
          meta: {
            title: '管理者管理',
            pankuzu: [],
          },
        },
        {
          path: 'tanto_edit/detail/:id',
          component: () => import('./views/page/TantoEdit.vue'),
          meta: {
            title: '管理者詳細',
            pankuzu: [],
          },
        },
        {
          path: 'user',
          component: () => import('./views/page/User.vue'),
          meta: {
            title: '利用者一覧',
            pankuzu: [],
          },
        },
        {
          path: 'user_edit',
          component: () => import('./views/page/UserEdit.vue'),
          meta: {
            title: '利用者管理',
            pankuzu: [],
          },
        },
        {
          path: 'user_edit/detail/:id',
          component: () => import('./views/page/UserEdit.vue'),
          meta: {
            title: '利用者詳細',
            pankuzu: [],
          },
        },
        {
          path: 'user/system/:id',
          component: () => import('./views/page/CollectSystem.vue'),
          meta: {
            title: '回収系統管理',
            pankuzu: [],
          },
        },
        {
          path: 'user/gasmeter/:user_id',
          component: () => import('./views/page/SaveGasmeter.vue'),
          meta: {
            title: 'ガスメーター登録',
            pankuzu: [],
          },
        },
        {
          path: 'user/gasmeter/:user_id/:id',
          component: () => import('./views/page/SaveGasmeter.vue'),
          meta: {
            title: 'ガスメーター詳細',
            pankuzu: [],
          },
        },
        {
          path: 'settings',
          component: () => import('./views/page/Setting.vue'),
          meta: {
            title: '設定',
            pankuzu: [],
          },
        },
        {
          path: 'download',
          component: () => import('./views/page/Download.vue'),
          meta: {
            title: 'ダウンロード',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/admin/gasmeter',
      name: 'gasmeter',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: 'system',
          component: () => import('./views/page/GasMeterBySystem.vue'),
          meta: {
            title: '系統別回収一覧',
            pankuzu: [],
          },
        },
        {
          path: 'supply_recovery',
          component: () => import('./views/page/SupplyRecovery.vue'),
          meta: {
            title: '供給回収一覧',
            pankuzu: [],
          },
        },
        {
          path: 'collect',
          component: () => import('./views/page/Collect.vue'),
          meta: {
            title: '回収一覧',
            pankuzu: [],
          },
        },
        {
          path: 'supply',
          component: () => import('./views/page/Supply.vue'),
          meta: {
            title: '供給一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/',
      component: () => import('./views/page/user/Login.vue'),
      meta: {
        title: 'ログインページ',
      },
    },
    {
      path: '/',
      name: 'user',
      component: () => import('./views/template/UserMain.vue'),
      children: [
        {
          path: 'top',
          component: () => import('./views/page/user/Top.vue'),
          meta: {
            title: '予約一覧',
            pankuzu: [],
          },
        },
        {
          path: 'download',
          component: () => import('./views/page/user/Download.vue'),
          meta: {
            title: 'ダウンロード',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/gasmeter',
      name: 'gasmeter',
      component: () => import('./views/template/UserMain.vue'),
      children: [
        {
          path: 'supply',
          component: () => import('./views/page/user/Supply.vue'),
          meta: {
            title: '供給一覧',
            pankuzu: [],
          },
        },
        {
          path: '/',
          component: () => import('./views/page/user/Gasmeter.vue'),
          meta: {
            title: 'ガスメーター一覧',
            pankuzu: [],
          },
        },
      ],
    },
  ]
});